import IconButton from '@mui/material/IconButton';
import Router from 'next/router';
import InstagramIcon from '@mui/icons-material/Instagram';

import { eventService } from '../../../services/homii-services';

const ConnectWithUsMenuComponent = () => {
    const onFacebookClick = () => {
        eventService.logCustomEvent('facebook_click_navbar', {
            description: 'Clicked on Facebook from navbar',
        });
        window.open('//www.facebook.com/Homiilifestyle/', '_blank');
    };

    const onInstagramClick = () => {
        eventService.logCustomEvent('instagram_click_navbar', {
            description: 'Clicked on Instragram from navbar',
        });
        window.open('//www.instagram.com/homiilifestyle/?hl=en', '_blank');
    };

    const onContactUsClick = () => {
        Router.push('/connect-with-us');
    };

    const onFAQClick = () => {
        Router.push('/faq').then(() => window.scrollTo(0, 0));
    };

    const onBlogClick = () => {
        Router.push('/blog').then(() => window.scrollTo(0, 0));
    };

    return (
        <>
            <div className="menu-grid-item menu-grid-md-6 menu-grid-lg-3">
                <h5 style={{ marginBottom: '15px' }}>Important Stuff</h5>
                <ul className='menu-list-root menu-list-padding'>
                    <div className='menu-list-item-text-root menu-list-item' role="button" id="menu-link-blog" onClick={onBlogClick}>
                        <span className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                            <div className="menu-list-item-text menu-link">
                                <span className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">Blog</span>
                            </div>  
                        </span>                      
                    </div>
                    <div className='menu-list-item-text-root menu-list-item' role="button" id="menu-link-contact-us" onClick={onContactUsClick}>
                        <span className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                            <div className="menu-list-item-text menu-link">
                                <span className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">Contact Us</span>
                            </div> 
                        </span>                       
                    </div>
                    <div className='menu-list-item-text-root menu-list-item' role="button" id="menu-link-faq" onClick={onFAQClick}>
                        <span className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                            <div className="menu-list-item-text menu-link">
                                <span className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">FAQ</span>
                            </div> 
                        </span>                       
                    </div>
                </ul>
            </div>

            <div className="menu-grid-item menu-grid-md-6 menu-grid-lg-3 connect-with-us-socials">
                <h5 style={{ marginBottom: '15px' }}>Social</h5>
                <IconButton
                    className="socials-button menu-button-base-root menu-icon-button-root"
                    id="menu-link-facebook"
                    onClick={onFacebookClick}
                >
                    <img
                        src="/assets/images/facebook_icon.png"
                        alt="Facebook"
                        className="socials-image"
                    />
                </IconButton>
                <IconButton
                    className="socials-button menu-button-base-root menu-icon-button-root"
                    id="menu-link-instagram"
                    onClick={onInstagramClick}
                >
                    <InstagramIcon style={{ color: 'white' }} />
                </IconButton>
            </div>
        </>
    );
};

export default ConnectWithUsMenuComponent;

